import type { OasWebCustomPageId } from '@ipfabric/utils';
import { ManualSeparationPage } from 'pages/Inventory/Sites/ManualSeparation/ManualSeparationPage';
import type { ReactNode } from 'react';

export const oasWebCustomPages: {
  [Key in OasWebCustomPageId]: ReactNode;
} = {
  manualSiteSeparation: <ManualSeparationPage />,
};
